import logError from 'App/babel/helpers/logError';
import { getAccountRelations } from 'App/services/AccountRelations';

/*
	Use resolveClientIds to resolve the id of the related client
	instead of the id of the relation.
*/

angular.module('services.accountRelations', []).service('accountRelations', [
	'$q',
	'Account',
	'AppService',
	'RequestBuilder',
	'SoliditetClient',
	'FeatureHelper',
	function ($q, Account, AppService, RequestBuilder, SoliditetClient, FeatureHelper) {
		var instance = {};

		var mapRelatedClient = function (relClient, type, relObj, resolveClientIds) {
			var relationSort = {
				parent: 1,
				sibling: 2,
				subsidiary: 3,
				connected: 4
			};
			relObj = relObj || {};
			relObj[type] = true;
			relObj.sort = relationSort[type];
			relObj.relatedToClientId = relClient.id;
			relObj.name = relClient.name;
			relObj.hasActivity = relClient.hasActivity;
			relObj.hasOpportunity = relClient.hasOpportunity;
			relObj.hasOrder = relClient.hasOrder;

			if (resolveClientIds) {
				relObj.id = relClient.id;
			}

			return relObj;
		};

		instance.mapCustomRelation = function (customerId, relation) {
			return Account.customer(customerId)
				.get(relation.relatedToClientId)
				.then(function (res) {
					return mapRelatedClient(res.data, 'connected', {
						descriptionChildParent: relation.descriptionChildParent,
						id: relation.id // id of the relation
					});
				});
		};

		instance.getCount = function (account, subAccountIds) {
			var subsidiaries;
			var customerId = AppService.getCustomerId();
			const accountIds = [account.id];
			if (subAccountIds?.length) {
				accountIds.push(...subAccountIds);
			}

			var filters = new RequestBuilder();
			filters.addFilter(Account.attr.parent.attr.id, filters.comparisonTypes.Equals, accountIds);
			filters.fields = ['id'];
			subsidiaries = Account.customer(customerId)
				.find(filters.build())
				.then(function (res) {
					return res.data.length;
				});

			let groupTree = 0;

			const hasGroupSize = FeatureHelper.isAvailable('GROUP_SIZE');
			const hasProspectingPro = FeatureHelper.isAvailable(FeatureHelper.Feature.PROSPECTING_PRO);
			const hasProspectingBasic = FeatureHelper.isAvailable(FeatureHelper.Feature.PROSPECTING_BASIC);
			const hasCompanyGroupCardFeature = FeatureHelper.isAvailable(FeatureHelper.Feature.COMPANY_GROUP_CARD);
			const showCommercial = !hasGroupSize && !hasProspectingPro && hasProspectingBasic;

			if (account.prospecting && hasCompanyGroupCardFeature && hasProspectingPro) {
				groupTree = 0;
			} else if (account.prospecting && (showCommercial || hasProspectingPro)) {
				groupTree = account.prospecting.groupSize > 1 ? 1 : 0;
			} else if (
				account.dunsNo &&
				account.dunsNo !== -1 &&
				account.dunsNo !== ' ' &&
				!isNaN(account.dunsNo) &&
				AppService.getSelf().userParams.soliditetIsActive &&
				AppService.getMetadata().params.soliditetIsActive &&
				hasGroupSize
			) {
				groupTree = SoliditetClient.customer(customerId)
					.find({ dunsNo: account.dunsNo })
					.then(res => (res.data?.length ? 1 : 0))
					.catch(e => {
						logError(e, 'Failed to load account relations', { id: account.id });
						return 0;
					});
			}

			const parentRelationsCount = account?.parent?.id ? 1 : 0;

			return $q
				.all({
					subsidiaries: subsidiaries,
					customConnections: account.connectedClients ? account.connectedClients.length : 0,
					groupTree
				})
				.then(function (res) {
					return res.subsidiaries + res.customConnections + res.groupTree + parentRelationsCount;
				});
		};

		// $q.when keeps the digest that $q.defer used to kick - editOrder and editAgreement still
		// assign scope-bound state inside .then, and the standalone returns a native promise.
		instance.get = function (account, resolveClientIds) {
			return $q.when(getAccountRelations(account, resolveClientIds));
		};

		return instance;
	}
]);
